(ns teamoesterreich.user-mode.prevent.answer-option
  (:require [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [teamoesterreich.store :as store]
            [teamoesterreich.user-mode.actions :as a]
            [teamoesterreich.user-mode.prevent.evaluate :as evaluate]
            [teamoesterreich.util.helper :as h]             ;;(h/event-value e)
            [teamoesterreich.util.log :as log]))





(defn new-answer-obj [ao-path answerOptionId answer-option a-obj]
  (merge {:active          false
          :type            (:type answer-option)
          :__answer-option (str ao-path answerOptionId)
          :timestamp       (js/Date.)
          :created         (js/Date.)
          :points          0}
         a-obj))

(defn answer-option-radios
  [answerOptionId answer-option answer-options question-response-cs & [answered-cb]]
  (let [options (map (fn [_ref] (.-id _ref)) (:option-references answer-option))
        answeredOptionId (reduce (fn [c v]
                                   ;(log/out "dgb " (clj->js (deref (r/cursor question-response-cs [:answers v :answer_radio_button]))))
                                   (if (deref (r/cursor question-response-cs [:answers v :answer_radio_button])) v c))
                                 options)
        answeredOptionValue (get-in answer-options [answeredOptionId :text])]
    [:div
     [mui/radio-group {:name          (:radio-group-name answer-option)
                       :valueSelected answeredOptionValue}
      (for [ref_ (:option-references answer-option)]
        (let [radio-option (get answer-options (.-id ref_))
              ]
          ^{:key (str "radio-option-" radio-option)} [mui/radio {:iconStyle {:fill "grey"}
                                                                 :disabled  true
                                                                 :style     {;:border-bottom "1px solid #999"
                                                                             :marginBottom "10px"}
                                                                 :label     (str " " (:text radio-option))
                                                                 :value     (str "" (:text radio-option))

                                                                 }])
        )
      ]
     [:br]]
    ))


(defn answer-option-checkbox_
  [answerOptionId answer-option answer-option-response-cs & [answered-cb]]
  (let [answer-option-resp (when answer-option-response-cs (deref answer-option-response-cs))
        answer (or (:answer_checkbox answer-option-resp) false)]
    (log/out (str "update option `" (:text answer-option) "` checked " answer-option-resp " " answer))
    [:div
     (mui/checkbox {:iconStyle {:fill "black"}
                    :label     (str (if ((keyword "text$dynamic") answer-option)
                                      (evaluate/calculate-and-set ((keyword "text$dynamic") answer-option))
                                      (:text answer-option)))
                    :checked   answer
                    :on-check  (fn [e v]
                                 (log/out (str "option `" (:text answer-option) "` checked " v))
                                 (answered-cb answerOptionId {:answer_checkbox v
                                                              :points          (if v (:points answer-option) 0)
                                                              :timestamp       (js/Date.)}))
                    })
     [:br]]
    ))

(defn answer-option-checkbox
  [answerOptionId answer-option answer-option-response-cs & [answered-cb]]
  (let [answer-option-resp (when answer-option-response-cs (deref answer-option-response-cs))
        answer (:answer_checkbox answer-option-resp)
        answer-click (fn [v]
                       (log/out (str "option `" (:text answer-option) "` checked " v))
                       (answered-cb answerOptionId {:answer_checkbox v
                                                    :points          (if v (:points answer-option) 0)
                                                    :timestamp       (js/Date.)}))]

    (log/out (str "update option `" (:text answer-option) "` checked " answer-option-resp " " answer))
    [mui/list-item
     {:key (str "answerOption" answerOptionId) :style {:textAlign "center"}}
     [mui/list-item-text
      (:text answer-option)
      [:br]
      [:div {:style {:textAlign "center"}}
       [mui/button {:style   {:marginBottom     "20px" :margin-top "10px" :margin-right "10px" :border "1px solid grey" :border-radius "15px"
                              :background-color (if (true? answer) "red" "white")
                              :color            (if (true? answer) "white" "red")
                              }
                    :onClick #(answer-click true)
                    } "Ja"]
       [mui/button {:style   {:marginBottom     "20px" :margin-top "10px" :margin-right "10px" :border "1px solid grey" :border-radius "15px"
                              :background-color (if (false? answer) "red" "white")
                              :color            (if (false? answer) "white" "red")
                              }
                    :onClick #(answer-click false)
                    } "Nein"]
       [mui/button {:style   {:marginBottom     "20px" :margin-top "10px" :border "1px solid grey" :border-radius "15px"
                              :background-color (if (nil? answer) "red" "white")
                              :color            (if (nil? answer) "white" "red")
                              }
                    :onClick #(answer-click nil)
                    } "?"]
       ]
      ]]
    ))

(defn answer-option-text
  [answerOptionId answer-option answer-option-response-cs & [answered-cb]]
  (let [answer-option-resp (when answer-option-response-cs (deref answer-option-response-cs))
        answer (:answer_text answer-option-resp)]
    [mui/list-item
     {:key (str "answerOption" answerOptionId) :style {:textAlign "center"}}
     [mui/list-item-text
      (:hint answer-option)
      [:br]
      [mui/text-field
       {:multiline    true
        :defaultValue (str "" answer)
        :onChange     (fn [e]
                        (let [value (h/event-value e)]
                          (answered-cb answerOptionId {:answer_text value
                                                       :points      (if value (:points answer-option) 0)
                                                       :timestamp   (js/Date.)})))
        }
       ]
      ]
     ]
    ))

(defn answer-option-numeric
  [answerOptionId answer-option answer-option-response-cs & [answered-cb]]
  (let [answer-option-resp (when answer-option-response-cs (deref answer-option-response-cs))
        answer (:answer_numeric answer-option-resp)]
    [mui/list-item
     {:key (str "answerOption" answerOptionId) :style {:textAlign "center"}}
     [mui/list-item-text
      (:hint answer-option)
      [:br]
      [mui/text-field
       {:multiline    false
        :fullWidth    true
        :defaultValue (str "" answer)
        :onChange     (fn [e]
                        (let [value (h/event-value e)]
                          (answered-cb answerOptionId {:answer_numeric value
                                                       :points         (if value (:points answer-option) 0)
                                                       :timestamp      (js/Date.)})))
        }
       ]
      ]
     ]
    ))


(defn answer-option-decimal
  [answerOptionId answer-option answer-option-response-cs & [answered-cb]]
  (let [answer-option-resp (when answer-option-response-cs (deref answer-option-response-cs))
        answer (:answer_decimal answer-option-resp)]
    [mui/list-item
     {:key (str "answerOption" answerOptionId) :style {:textAlign "center"}}
     [mui/list-item-text
      (:hint answer-option)
      [:br]
      [mui/text-field
       {:multiline    false
        :defaultValue (str "" answer)
        :onChange     (fn [e]
                        (let [value (h/event-value e)]
                          (answered-cb answerOptionId {:answer_decimal value
                                                       :points         (if value (:points answer-option) 0)
                                                       :timestamp      (js/Date.)})))
        }
       ]
      ]
     ]
    ))


(defn answer-option
  [answerOptionId answer-option answer-options question-response-cs answer-option-response-cs q-answered-cb]
  (log/out "answer-option ->" (clj->js answer-option) (clj->js @answer-option-response-cs q-answered-cb))

  ^{:key (str "answerOption-" answerOptionId)} (case (:type answer-option)
                                                 "radio_button" nil
                                                 "image" nil
                                                 "radio_group" ""
                                                 "checkbox" (answer-option-checkbox answerOptionId answer-option answer-option-response-cs q-answered-cb)
                                                 "text" (answer-option-text answerOptionId answer-option answer-option-response-cs q-answered-cb)
                                                 "numeric" (answer-option-numeric answerOptionId answer-option answer-option-response-cs q-answered-cb)
                                                 "decimal" (answer-option-decimal answerOptionId answer-option answer-option-response-cs q-answered-cb)
                                                 [mui/list-item {:key (str "answerOption" answerOptionId) :style {:color "red"}} (str (:type answer-option) "  " (:text answer-option))])
  )



(defn answer-options [questionnaireId questionId question-cs question-response-cs q-answered-cb]
  (let [answer-options (:answer-options @question-cs)]
    (log/out "answer-options-app ->" (clj->js @question-cs) (clj->js @question-response-cs))
    [mui/list {:style {:margin "0 40px 0 40px" :textAlign "center"}}
     (for [[answerOptionId ao] (sort-by (fn [[uuid e]] (:index e)) answer-options)]
       (let [
             answer-option-response-cs (r/cursor question-response-cs [:answers answerOptionId])
             ao-base-path (str "/questionnaires/" questionnaireId "/questions/" questionId "/answer-options/")
             ao-path (str ao-base-path answerOptionId)
             answered-cb (fn [answerOptionId answer-obj]
                           (let [answer-option-response-cs (r/cursor question-response-cs [:answers answerOptionId])
                                 answer-obj (if @answer-option-response-cs
                                              (merge @answer-option-response-cs answer-obj)
                                              (new-answer-obj ao-path answerOptionId ao answer-obj))
                                 ]
                             (log/out "Set answer-object XXX " (:triggers answer-obj) " -- " (clj->js answer-obj) a/set-user-questionnaire-answer)
                             (a/set-user-questionnaire-answer questionnaireId questionId answerOptionId answer-obj)
                             (reset! (r/cursor store/app-state [:user-questionnaires questionnaireId :questions questionId :answers answerOptionId]) answer-obj)


                             ;(when (> (count (:triggers ao)) 0) (trigger-helper/trigger-all ao-path nil ao answer-obj (:triggers ao)))


                             (q-answered-cb))
                           )
             ]
         (answer-option answerOptionId ao answer-options question-response-cs answer-option-response-cs answered-cb)))]))














